interface IStorageItem<T> {
  value: T
  expiry: number | null
}

export const setStorageItemWithExpiry = (
  key: string,
  value: unknown,
  ttl?: number
): void => {
  // ttl - time to live
  const item = {
    value: value,
    expiry: ttl ? Date.now() + ttl : null,
  }

  localStorage.setItem(key, JSON.stringify(item))
}

export const getStorageItemWithExpiry = <T>(key: string): null | T => {
  try {
    const item = localStorage.getItem(key)
    if (!item) return null
    const parsedItem: IStorageItem<T> = JSON.parse(item)
    // compare the expiry time of the item with the current time
    if (parsedItem.expiry && Date.now() > parsedItem.expiry) {
      // If the item is expired, delete the item from storage and return null
      localStorage.removeItem(key)

      return null
    }
    return parsedItem.value
  } catch {
    return null
  }
}
